import { createFileRoute } from "@tanstack/react-router";

import { SocialPublishing } from "@/features/social-publishing";
import { publishSearchSchema } from "@/features/social-publishing/publishSearch";
import { usePageTitle } from "@/hooks/usePageTitle";
import { requireSocialPublishingFeatureFlag } from "@/lib/posthog-flags";

export const Route = createFileRoute("/_auth/_app-shell/publish/")({
  beforeLoad: requireSocialPublishingFeatureFlag,
  component: RouteComponent,
  validateSearch: publishSearchSchema,
});

function RouteComponent() {
  usePageTitle("Publish");
  const { tab, view } = Route.useSearch();

  return <SocialPublishing tab={tab} view={view} />;
}
